var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretleftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0759 15.4916L6.42592 10.8333C6.27071 10.6771 6.18359 10.4659 6.18359 10.2458C6.18359 10.0256 6.27071 9.8144 6.42592 9.65826L11.0759 4.99993C11.1925 4.88241 11.3414 4.80226 11.5037 4.7697C11.666 4.73714 11.8343 4.75365 11.9872 4.81712C12.14 4.88059 12.2705 4.98815 12.362 5.12609C12.4535 5.26402 12.5019 5.42608 12.5009 5.5916V14.8999C12.5019 15.0655 12.4535 15.2275 12.362 15.3654C12.2705 15.5034 12.14 15.6109 11.9872 15.6744C11.8343 15.7379 11.666 15.7544 11.5037 15.7218C11.3414 15.6893 11.1925 15.6091 11.0759 15.4916Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretleftIcon);
export default __webpack_public_path__ + "static/media/caretleft_icon.b8879a7cb0a4fe215a15c26314e03a0a.svg";
export { ForwardRef as ReactComponent };